import {UseMutationOptions, useMutation, useQueryClient} from '@tanstack/react-query'
import {httpChangeFreelancerEmail, HttpChangeFreelancerEmailOption} from '@features/settings/http/settings.http.ts'
import {User} from '@features/user/types.ts'
import {errorHandler} from '@utilities/helpers.ts'
import {QUERY_KEYS} from '@/queryClient.ts'

export const useChangeFreelancerEmail = (
    options?: Omit<
        UseMutationOptions<unknown, unknown, HttpChangeFreelancerEmailOption['payload']>,
        'mutationFn' | 'mutationKey'
    >
) => {
    const queryClient = useQueryClient()

    return useMutation<unknown, unknown, HttpChangeFreelancerEmailOption['payload']>({
        mutationFn: variables =>
            httpChangeFreelancerEmail({
                payload: variables,
                params: {response_type: 'extended'}
            }),
        onError: errorHandler,
        onSuccess: async (data, variables, context) => {
            await queryClient.cancelQueries({queryKey: [QUERY_KEYS.ME]})
            queryClient.setQueryData(
                [QUERY_KEYS.ME],
                (previousData: User): User => ({
                    ...previousData,
                    newEmail: variables.new_email
                })
            )
            options?.onSuccess?.(data, variables, context)
        }
    })
}
